import React from 'react'
import { Row, Col, Card, Typography, Space, Carousel } from 'antd'
import { GlobalOutlined, SafetyOutlined, ShopOutlined, TeamOutlined } from '@ant-design/icons'
import './Home.scss'

// 引入图片（需自行替换为设计稿图片，放在src/assets/images/下）
import bannerImg from '../../assets/images/banner.jpg'
import bannerImg2 from '../../assets/images/banner2.jpg'
import bannerImg3 from '../../assets/images/banner3.jpg'
import advantageImg from '../../assets/images/advantage.jpg'
import isoImg from '../../assets/images/isoparaffin.png'
import hcImg from '../../assets/images/hydrocarbon.png'
import paoImg from '../../assets/images/pao.png'
import laoImg from '../../assets/images/lao.png'

const { Title, Paragraph, Text } = Typography

const Home = () => {
  // 产品数据
  const productList = [
    {
      title: 'Isoparaffin',
      img: isoImg,
      tags: ['Royal Dutch shell', 'ExxonMobil Isoparaffin', 'Isoparaffin', 'Qiang international Isoparaffin']
    },
    {
      title: 'Hydrocarbon solvent',
      img: hcImg,
      tags: ['Royal Dutch shell Solvents', 'ExxonMobil Hydrocarbon Solvents']
    },
    {
      title: 'Polyalphaolefin PAO',
      img: paoImg,
      tags: ['Chevron', 'ExxonMobil PAO']
    },
    {
      title: 'Linear Olefin LAO',
      img: laoImg,
      tags: ['Chevron Linear Olefin LAO', 'Korea Daesim Polyisobutylene PIB']
    }
  ]

  // 优势数据
  const advantageList = [
    {
      icon: <GlobalOutlined />,
      title: 'Intensive service network'
    },
    {
      icon: <SafetyOutlined />,
      title: 'Modular solution'
    },
    {
      icon: <ShopOutlined />,
      title: 'Flexible sales strategy'
    },
    {
      icon: <TeamOutlined />,
      title: 'Senior technical team'
    }
  ]

  return (
    <div className='home-page'>
      {/* 1. Banner区域 */}
      <section className='banner-section'>
        <div className='banner-bg'>
          <Carousel autoplay>
            <div className='banner-item banner-item-1'></div>
            <div className='banner-item banner-item-2' style={{ backgroundImage: `url(${bannerImg2})` }}></div>
            <div className='banner-item banner-item-3' style={{ backgroundImage: `url(${bannerImg3})` }}></div>
          </Carousel>
        </div>
      </section>

      {/* 2. 产品区域 */}
      <section className='product-section section'>
        <div className='section-inner'>
          <Title level={3} className='section-title'>
            products
          </Title>
          <Row gutter={[20, 20]}>
            {productList.map((item, index) => (
              <Col
                key={index}
                xs={24} // 移动端1列
                sm={6} // 平板4列
                md={6} // 桌面4列
                className='product-item'
              >
                <Card
                  hoverable
                  cover={<img alt={item.title} src={item.img} className='product-img' />}
                  className='product-card'
                >
                  <Title level={5} className='product-card-title'>
                    {item.title}
                  </Title>
                  <Space direction='vertical' size='small' className='product-tags'>
                    {item.tags.map((tag, i) => (
                      <Text key={i} className='tag-text'>
                        {tag}
                      </Text>
                    ))}
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* 3. 优势区域 */}
      <section className='advantage-section section'>
        <div className='section-inner'>
          <Row gutter={[30, 20]} align='middle'>
            {/* 优势文字：移动端占满行，桌面端占10列 */}
            <Col xs={24} md={10}>
              <Title level={3} className='section-title'>
                ADVANTAGE
              </Title>
              <Paragraph className='advantage-desc'>
                "Integrity service, positive development" is our business purpose, "grow together with customers and
                achieve win-win results" is our goal.
              </Paragraph>
              <div className='advantage-list'>
                {advantageList.map((item, index) => (
                  <div key={index} className='advantage-item'>
                    <span className='advantage-icon'>{item.icon}</span>
                    <span className='advantage-text'>{item.title}</span>
                  </div>
                ))}
              </div>
            </Col>
            {/* 优势图片：移动端占满行，桌面端占14列 */}
            <Col xs={24} md={14}>
              <img src={advantageImg} alt='Advantage' className='advantage-img' width='100%' />
            </Col>
          </Row>
        </div>
      </section>

      {/* 4. 关于我们区域 */}
      <section className='about-section section'>
        <div className='about-bg'>
          <div className='section-inner'>
            <Title level={3} className='section-title about-title'>
              ABOUT US
            </Title>
            <Row gutter={[30, 20]}>
              {/* 关于文字：移动端占满行，桌面端占16列 */}
              <Col xs={24} md={16}>
                <Paragraph className='about-desc'>
                  We specialize in the distribution of imported chemicals in the Chinese market and the export sales of
                  domestic chemicals. Our products include organic and inorganic chemicals, agrochemicals,
                  intermediates, special and custom chemicals, and new materials, covering a wide range of industries,
                  such as pharmaceuticals, agrochemicals, dyes, flavors and fragrances, daily chemicals, lubricants,
                  electronics, solar energy, industry and construction.
                </Paragraph>
              </Col>
              {/* 数据统计：移动端占满行，桌面端占8列 */}
              <Col xs={24} md={8}>
                <Row gutter={[20, 0]} className='about-stats'>
                  <Col xs={8} sm={8} md={8}>
                    <div className='stat-item'>
                      <Text className='stat-num'>2+</Text>
                      <Text className='stat-text'>Production line</Text>
                    </div>
                  </Col>
                  <Col xs={8} sm={8} md={8}>
                    <div className='stat-item'>
                      <Text className='stat-num'>1+</Text>
                      <Text className='stat-text'>Honor</Text>
                    </div>
                  </Col>
                  <Col xs={8} sm={8} md={8}>
                    <div className='stat-item'>
                      <Text className='stat-num'>12+</Text>
                      <Text className='stat-text'>Cooperation</Text>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
